import * as React from "react"
import injectSheet from "react-jss"
import compose from "recompose/compose"
import { withi18n } from "@/helpers/hoc/withi18n"
import { dateShort } from "@/helpers/dates"
import { Input } from "@xingternal/360-components"

const styles = {
  dateInputs: { composes: "flex pt8", width: 260 },
  input: { composes: "cursor-pointer" },
  separator: { composes: "p8" },
}

const i18n = {
  from: "360_RECRUITER_INSIGHTS_FROM",
  to: "360_RECRUITER_INSIGHTS_TO",
}

class DateRangeInputs extends React.Component {
  state = {
    from: dateShort(this.props.dateRange.from),
    to: this.props.dateRange.to ? dateShort(this.props.dateRange.to) : "",
  }

  componentDidUpdate(prevProps, prevState) {
    const { from, to } = this.props.dateRange

    if (prevProps.dateRange.from !== from || prevProps.dateRange.to !== to) {
      this.setState(state => ({
        from: dateShort(from),
        to: to ? dateShort(to) : "",
      }))
    }
  }

  render() {
    const {
      props: { classes, onInputDateFocus, from: i18nFrom, to: i18nTo },
      state: { from, to },
    } = this

    return (
      <React.Fragment>
        <div className={classes.dateInputs}>
          <label htmlFor="dateRangeInputFrom" className="hidden">
            {i18nFrom}
          </label>
          <Input
            value={from}
            onFocus={() => onInputDateFocus("from")}
            placeholder="DD/MM/YY"
            id="dateRangeInputFrom"
            inputClassName={classes.input}
          />
          <div className={classes.separator}>–</div>
          <label htmlFor="dateRangeInputTo" className="hidden">
            {i18nTo}
          </label>
          <Input
            value={to}
            onFocus={() => onInputDateFocus("to")}
            placeholder="DD/MM/YY"
            id="dateRangeInputTo"
            inputClassName={classes.input}
          />
        </div>
      </React.Fragment>
    )
  }
}

const enhance = compose(
  withi18n(i18n),
  injectSheet(styles),
)

export default enhance(DateRangeInputs)
